import { makeStyles } from 'tss-react/mui';

const useStylesSearchFieldBlock: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  searchFieldBlockField: {
    '& > div > input': {
      height: 10,
      padding: 15,
      backgroundColor: theme.palette.background.default,
    },
    [theme.breakpoints.up('md')]: {
      minWidth: '300px !important',
    },
    [theme.breakpoints.down('sm')]: {
      width: 'calc(100% - 50px)',
    },
  },
  searchFieldBlockFieldFloat: {
    paddingLeft: '7px !important',
    paddingRight: '7px !important',
    '& > div': {
      '&:before, &:after': {
        display: 'none',
      },
      '& > input:focus': {
        position: 'relative',
        width: 'calc(100vw - 32px) !important',
        height: 32,
        left: '-254px !important',
        '&:before:focus, &:after:focus': {
          left: '-254px !important',
        },
      },
    },
  },
  searchFieldBlockButton: {
    color: `${theme.palette.common.white} !important`,
    padding: '8px 12px !important',
    backgroundColor: `${theme.palette.secondary.main} !important`,
    borderRadius: '0 !important',
  },
  searchFieldBlockButtonPlain: {
    right: -2,
  },
}));

export default useStylesSearchFieldBlock;
